<template lang="pug">
  b-modal#actionLogInfo(
  ref="actionLogInfoModal"
  :title="$t('ui.action_log')"
  centered
  no-fade
  ok-only
  no-enforce-focus
  size="lg"
  :busy="loading"
  @show="reset")
    div(v-if="info")
      div.row
        div.col-6
          b-form-group(:label="$t('ui.action')").mb-3
            div.form-control.form-control-sm.disabled {{ info.action }}
        div.col-6
          b-form-group(:label="$t('ui.date_time')").mb-3
            div.form-control.form-control-sm.disabled {{ $moment(info.dateTime).format("YYYY-MM-DD HH:mm:ss") }}
      div.row
        div.col-6
          b-form-group(:label="$t('ui.status')").mb-3
            div.form-control.form-control-sm.disabled {{ info.status }}
        div.col-6
          b-form-group(:label="$t('ui.ip_address')").mb-3
            div.form-control.form-control-sm.disabled {{ info.ipAddress }}
      div.row
        div.col-12
          b-form-group(:label="$t('ui.status_desc')").mb-3
            b-form-textarea(v-model="info.statusDesc" disabled=true style="height:80px;")
      div.row
        div.col-12
          b-form-group(:label="$t('ui.browser_agent')").mb-3
            div.form-control.form-control-sm.disabled {{ info.browserAgent }}
      div.row
        div.col-6
          b-form-group(:label="$t('ui.domain_name')").mb-3
            div.form-control.form-control-sm.disabled {{ info.domainName }}
        div.col-6
          b-form-group(:label="$t('ui.action_by')").mb-3
            div.form-control.form-control-sm.disabled {{ info.actionBy }}
      div.row
        div.col-6
          b-form-group(:label="$t('ui.target_id')").mb-3
            div.form-control.form-control-sm.disabled {{ info.targetId }}
        div.col-6
          b-form-group(:label="$t('ui.target_action')").mb-3
            div.form-control.form-control-sm.disabled {{ info.targetAction }}
      div
        b-form-group(:label="$t('ui.details')").mb-3
          div.row.mb-3(v-if="info.details").animated.fadeIn
            div.col
              table.tablex(style="width: 100%;")
                thead
                  tr
                    th(width=150)
                      span {{ $tc('ui.key', 1) }}
                    th
                      span {{ $tc('ui.value', 1) }}
                tbody
                  tr(v-for="(item, index) in info.details")
                    td
                      span {{ item.key }}
                    td
                      span {{ item.value }}
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-check" :text="$t('ui.ok')" isModal=true)
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";

export default {
  components: {
    SubmitButton
  },
  props: {
    info: {
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  methods: {
    reset() {

    },
  }
};
</script>

<style lang="scss" scoped>
</style>
